// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import org.mifospay.core.model.interbank.InterBankParticipantRequest
import org.mifospay.core.model.interbank.InterBankParticipantResponse
import org.mifospay.core.model.interbank.InterBankPartyInfoRequest
import org.mifospay.core.model.interbank.InterBankPartyInfoResponse
import org.mifospay.core.model.interbank.InterBankTransferRequest
import org.mifospay.core.model.interbank.InterBankTransferResponse

@OptIn(InternalKtorfitApi::class)
public class _InterBankServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : InterBankService {
  override suspend fun fetchParticipant(request: InterBankParticipantRequest): InterBankParticipantResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "participant")
        }
        setBody(request) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<InterBankParticipantResponse>(),)!! 
  }

  override suspend fun fetchPartyInfo(request: InterBankPartyInfoRequest): InterBankPartyInfoResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "partyinfo")
        }
        setBody(request) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<InterBankPartyInfoResponse>(),)!! 
  }

  override suspend fun interBankMakeTransfer(request: InterBankTransferRequest): InterBankTransferResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "executetransfer")
        }
        setBody(request) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<InterBankTransferResponse>(),)!! 
  }
}

public class _InterBankServiceProvider : ClassProvider<InterBankService> {
  override fun create(_ktorfit: Ktorfit): InterBankService = _InterBankServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createInterBankService(): InterBankService = _InterBankServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
